/**
 * Punto de entrada de la aplicación.
 *
 * Monta Vue con tres piezas transversales:
 *  - **Pinia con persistencia**: el plugin se registra ANTES de `app.use(pinia)`
 *    para que los stores con `persist: true` —hoy solo el de sesión— restauren su
 *    estado desde el almacenamiento del navegador ya en el primer render.
 *  - **Router**: instala el guard global de autenticación y permisos.
 *  - **Directiva `v-drag-scroll`**: registrada globalmente porque la usan varias
 *    vistas del árbol.
 *
 * No se hace ninguna llamada al API aquí: la sesión la resuelve el guard del
 * router, que espera a que Firebase determine el estado inicial antes de decidir.
 */

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import persistedState from 'pinia-plugin-persistedstate'
import { vDragScroll } from './directives/dragScroll'

const pinia = createPinia()
const app = createApp(App)
pinia.use(persistedState)
app.directive('drag-scroll', vDragScroll)
app.use(router).use(pinia).mount('#app')
